import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import WebsiteForm from '../../../components/publisher/websites/WebsiteForm';

class WebsiteEdit extends Component {
  render() {
    const { website } = this.props;

    return (
      <div>
        <WebsiteForm isModal={false} website={website} formAction={'Update'} />
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'WebsiteForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader, publisher: { websites } } = state;
  const { params: { websiteName } } = ownProps;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteName)[0] || {};
  const isLoading = loader.includes('WebsiteForm');

  const initialValues = {
    website: {
      name: website.name,
      url: website.url,
      cpa: website.cpa,
      cpc: website.cpc,
      default_slots: website.default_slots,
      sandbox: website.sandbox === true ? 'sandbox' : 'live'
    }
  };

  return { isLoading, initialValues, websites, website };
};

export default connect(mapStateToProps)(ResourceForm(WebsiteEdit));
